import Parse from "parse";

import type { SIV_Container } from "./SIV_Container";
import type { SIV_GoodsReceiptProcess } from "./SIV_GoodsReceiptProcess";
import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_ContainerItemAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  container: SIV_Container;
  goodsReceiptProcess: SIV_GoodsReceiptProcess;
  goodsReceiptProcessPosition?: SIV_GoodsReceiptProcessPosition | undefined;
  notFoundValues: any;
  packedQuantity?: number | undefined;
  packedWeight?: number | undefined;
  tenant?: OD3_Tenant | undefined;
}

export class SIV_ContainerItem extends Parse.Object<SIV_ContainerItemAttributes> {
  static className: string = "SIV_ContainerItem";

  constructor(data?: Partial<SIV_ContainerItemAttributes>) {
    super("SIV_ContainerItem", data as SIV_ContainerItemAttributes);
  }

  get container(): SIV_Container {
    return super.get("container");
  }
  set container(value: SIV_Container) {
    super.set("container", value);
  }

  get goodsReceiptProcess(): SIV_GoodsReceiptProcess {
    return super.get("goodsReceiptProcess");
  }
  set goodsReceiptProcess(value: SIV_GoodsReceiptProcess) {
    super.set("goodsReceiptProcess", value);
  }

  get goodsReceiptProcessPosition():
    | SIV_GoodsReceiptProcessPosition
    | undefined {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(
    value: SIV_GoodsReceiptProcessPosition | undefined,
  ) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get packedQuantity(): number | undefined {
    return super.get("packedQuantity");
  }
  set packedQuantity(value: number | undefined) {
    super.set("packedQuantity", value);
  }

  get packedWeight(): number | undefined {
    return super.get("packedWeight");
  }
  set packedWeight(value: number | undefined) {
    super.set("packedWeight", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("SIV_ContainerItem", SIV_ContainerItem);
